// app/not-found.tsx
'use client';

import { YStack, Text, Button } from '@ninjacart/nc-nk-ui';

export default function NotFound() {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <YStack f={1} ai="center" jc="center" height="100%" backgroundColor="$background">
      <Text fontSize={'$10'} fontWeight="bold" color="$color">
        404 - Page Not Found
      </Text>
      <Text mt="$2" color="$grey">
        Sorry, we couldn't find the page you're looking for.
      </Text>
      <Button mt="$4" variant="outlined" onPress={handleGoHome}>
        Go Home
      </Button>
    </YStack>
  );
}
